export default __webpack_public_path__ + "static/media/populationMap.dac70658.png";